import { render, staticRenderFns } from "./classificationManagement.vue?vue&type=template&id=50f36fbc&scoped=true&"
import script from "./classificationManagement.vue?vue&type=script&lang=js&"
export * from "./classificationManagement.vue?vue&type=script&lang=js&"
import style0 from "./classificationManagement.vue?vue&type=style&index=0&id=50f36fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f36fbc",
  null
  
)

export default component.exports